/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const MultiValue = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.MultiValue;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

MultiValue.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      MultiValue: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

MultiValue.defaultProps = {
  selectProps: {
    custom: {
      MultiValue: null,
    },
  },
  children: null,
};

export default MultiValue;
